import { Component, OnInit } from "@angular/core";
import { TitleService } from "@app/services/title.service";

@Component({
    selector: "app-services-page",
    templateUrl: "./services-page.component.html",
    styleUrls: ["./services-page.component.scss"],
})
export class ServicesPageComponent implements OnInit {
    constructor(private titleService: TitleService) {}

    ngOnInit(): void {
        this.titleService.setTitle("Platforms");
    }

    pageTitleArea: pageTitle[] = [
        {
            title: "Platforms",
        },
    ];
    singleSolutionsBox: solutionsBoxContent[] = [
        {
            icon: "/assets/img/funfacts/kepler.png",
            title: "Kepler",
            imageClass: "kepler",
            paragraphText:
                "Engineers, analysts, data scientists, and others can use Kepler to initiate projects and evaluate new use cases from a strategic rather than transactional standpoint. Kepler allows teams to do what they do best – use data to tackle business challenges head-on.",
            link: "platforms-kepler",
            linkText: "View Details",
        },
        {
            icon: "/assets/img/funfacts/mdp-logo.png",
            title: "MDP",
            imageClass: "",
            paragraphText:
                "An integrated and modern data platform that centralizes and exposes key unconventional datasets to end users amplifies the business value and enables acceleration of critical decisions and insights through analytics.",
            link: "platforms-mdp",
            linkText: "View Details",
        },
        {
            icon: "/assets/img/funfacts/UDA.png",
            title: "UDA",
            imageClass: "",
            paragraphText:
                "The Upstream Digital Accelerator (UDA) Data Platform, or The LakeHouse, is a system of reference developed and designed to join disparate data sources and provide simplified access to upstream data for Western Canadian Heavy Oil assets.",
            link: "platforms-uda",
            linkText: "View Details",
        },
        {
            icon: "/assets/img/funfacts/OSDU.png",
            title: "OSDU",
            imageClass: "",
            paragraphText:
                "An industry-wide initiative to create a cloud-agnostic open subsurface environment. OSDU objectives are analogous to those of the Upstream Data Foundation (UDF) focused on surface and commercial data, whereas OSDU is focused on subsurface data.",
            link: "platforms-osdu",
            linkText: "View Details",
        },
    ];
}
class pageTitle {
    title: string;
}
class solutionsBoxContent {
    icon: string;
    title: string;
    imageClass: string;
    paragraphText: string;
    link: string;
    linkText: string;
}
